import {CasinofiedZoidApplicationAdapter} from "./casinofied-zoid-application-adapter";
import {AppIdentifiers, IAppClosedTopicPayload, IDivHostedAppInitParameters} from "@sparkware/uc-sdk-core";

export class PaymentsRedirectZoidAdapter extends CasinofiedZoidApplicationAdapter {
    protected _onClose(payload: IAppClosedTopicPayload, initParams: IDivHostedAppInitParameters) {
        this.applicationSdk.close(this.appID);
        super._onClose({
                ...payload,
                appID: AppIdentifiers.Redirect
            },
            initParams);
    }
}